import DapDSCheckbox from './checkbox.component'

export * from './checkbox.component'
export default DapDSCheckbox

DapDSCheckbox.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-checkbox': DapDSCheckbox
  }
}
